import { HXCircleIcon, ImageKit, Typography } from "@aph/ui-lib-humanx";
import IconPlus from "$/icons/icon-plus.svg";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import styles from "./QuotesCard.module.scss";

const QuotesCards = (props) => {
  const { Quote, title, AuthorName } = props?.data;

  return (
    <div className={styles.root}>
      <HXCircleIcon iconStyle="style2" className={styles.bgStyle} />
      <div className={styles.contentSection}>
        <div className={styles.quoteIcon}>
          <ImageKit
            width={50}
            height={50}
            src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/quoteCard.svg`}
            alt={"quote img"}
          />
        </div>
        {title && (
          <Typography component="h3" className={styles.title}>
            {title}
          </Typography>
        )}

        {Quote && <div dangerouslySetInnerHTML={{ __html: Quote }} className={styles.title} />}
        <Typography className={styles.authorDetail}>
          <span>
            <IconPlus width={13} height={13} />
          </span>
          {AuthorName}
        </Typography>
      </div>
    </div>
  );
};

export default QuotesCards;
